import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7da552fc = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _ac8dcd92 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _114eeb20 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _5e781189 = () => interopDefault(import('..\\pages\\insurance.vue' /* webpackChunkName: "pages_insurance" */))
const _6ed82f68 = () => interopDefault(import('..\\pages\\insurance-information.vue' /* webpackChunkName: "pages_insurance-information" */))
const _56bd115a = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _1aaa02e5 = () => interopDefault(import('..\\pages\\prescriber-information.vue' /* webpackChunkName: "pages_prescriber-information" */))
const _0d60c738 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _443d1d76 = () => interopDefault(import('..\\pages\\select-path.vue' /* webpackChunkName: "pages_select-path" */))
const _586847f2 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _096aebb6 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _24b53356 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _6ca64a98 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _6cb46219 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _6cd0911b = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _6cdea89c = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _bce6f44e = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _65f2fb01 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/eligibility",
    component: _7da552fc,
    name: "eligibility"
  }, {
    path: "/error",
    component: _ac8dcd92,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _114eeb20,
    name: "have-a-card"
  }, {
    path: "/insurance",
    component: _5e781189,
    name: "insurance"
  }, {
    path: "/insurance-information",
    component: _6ed82f68,
    name: "insurance-information"
  }, {
    path: "/patient-information",
    component: _56bd115a,
    name: "patient-information"
  }, {
    path: "/prescriber-information",
    component: _1aaa02e5,
    name: "prescriber-information"
  }, {
    path: "/rejection",
    component: _0d60c738,
    name: "rejection"
  }, {
    path: "/select-path",
    component: _443d1d76,
    name: "select-path"
  }, {
    path: "/success",
    component: _586847f2,
    name: "success"
  }, {
    path: "/unlock",
    component: _096aebb6,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _24b53356,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _6ca64a98,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _6cb46219,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _6cd0911b,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _6cdea89c,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _bce6f44e,
    name: "errors-500"
  }, {
    path: "/",
    component: _65f2fb01,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
